import { render, staticRenderFns } from "./programm.vue?vue&type=template&id=8b56310c&scoped=true"
import script from "./programm.vue?vue&type=script&lang=js"
export * from "./programm.vue?vue&type=script&lang=js"
import style0 from "./programm.vue?vue&type=style&index=0&id=8b56310c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b56310c",
  null
  
)

export default component.exports